import React, { useState } from 'react';

import { Flex } from 'components/base/layout-components';
import { TRACKING } from 'common/constants/constants';

import BeforeSubmit from './BeforeSubmitEmailPreferences';
import AfterSubmit from './AfterSubmitEmailPreferences';

import { unsubscribe } from 'common/services/unsubscribe.service';
import * as TrackingService from 'common/services/tracking.service';
import useQueryParam from 'components/hooks/useQueryParam';
import { BACKGROUND_TYPES, BackgroundContainer } from 'components/Background';

const UNSUBSCRIBE_TOKEN_QUERY_PARAM = 'ut';
const EMAIL_TOKEN_QUERY_PARAM = 'email';

const onUnsubscribe = async ut => {
  const { recipient_id: email } = await unsubscribe(ut);

  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.UNSUBSCRIBE,
    click_type: TRACKING.CLICK.UNSUBSCRIBE,
    email
  });
};

const EmailPreferences = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const ut = useQueryParam({
    paramName: UNSUBSCRIBE_TOKEN_QUERY_PARAM,
    shouldOmit: true
  });
  const email = useQueryParam({
    paramName: EMAIL_TOKEN_QUERY_PARAM,
    shouldOmit: true
  });

  const onSubmit = async () => {
    await onUnsubscribe(ut);
    setIsSubmitted(true);
  };

  return (
    <BackgroundContainer
      type={BACKGROUND_TYPES.HIVE}
      items='center'
      justify='center'
    >
      <Flex
        justify='center'
        width='60vw'
        height='65vh'
        backgroundColor='rgba(246, 246, 246, 0.5)'
        style={{
          padding: '120px 120px 140px 120px',
          boxSizing: 'border-box'
        }}
      >
        {!isSubmitted ? (
          <BeforeSubmit email={email} onSubmit={onSubmit} />
        ) : (
          <AfterSubmit />
        )}
      </Flex>
    </BackgroundContainer>
  );
};

export default EmailPreferences;
